const saveGuidance = 'Não conseguimos confirmar o salvamento de todas as respostas. Não feche nem atualize esta página. Tente novamente. Se continuar, avise o prestador do guincho.';

export function publicChecklistErrorMessage(error: unknown, fields: Array<{ id: string; nome: string }> = []): string {
  const detail = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  if ((error as { code?: string } | null)?.code === 'checklist_share_timeout' || /timeout/i.test(detail)) {
    return 'A conexão demorou e ainda não conseguimos confirmar o salvamento. Suas respostas continuam nesta página. Não feche nem atualize. Use “Tentar salvar novamente”.';
  }
  const status = (error as { shareStatus?: string; statusCode?: number } | null)?.shareStatus;
  if (status === 'expired' || status === 'revoked' || /expirad|revogad|não está ativo/i.test(detail)) {
    return 'Este link expirou ou foi desativado. Peça um novo link ao prestador do guincho para continuar.';
  }
  if (/Um campo excede o tamanho permitido/.test(detail)) return `Reduza o texto do campo que excede o tamanho permitido. ${saveGuidance}`;
  const match = /^Campo ([^:]+): (.+)$/.exec(detail);
  if (match) {
    const name = fields.find((field) => field.id === match[1])?.nome;
    const reason = /Timestamp inválido/i.test(match[2]) ? 'informe uma data e hora válidas'
      : /numérico inválido/i.test(match[2]) ? 'informe um número válido'
      : /dropdown não permitido/i.test(match[2]) ? 'selecione uma opção disponível'
      : /limite permitido/i.test(match[2]) ? 'reduza o tamanho da resposta'
      : null;
    if (name && reason) return `${name}: ${reason}. ${saveGuidance}`;
  }
  return saveGuidance;
}
